module.exports = "pegasus_template/assets/theme2/small/7.jpg";